const DEFAULT_ICON = '📄'

export { DEFAULT_ICON }
